import { render } from "./DeletedNotesTable.vue?vue&type=template&id=c64d5dc2"
import script from "./DeletedNotesTable.vue?vue&type=script&lang=js"
export * from "./DeletedNotesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__